// extracted by mini-css-extract-plugin
module.exports = {"LikeControl__btn":"jg_a"};